import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Tooltip } from '@mui/material'
import React, { useRef } from 'react'
import { Resolution } from '../../types'
import ExportMenu from './ExportMenu'
import ExportButton from './ExportButton'
import { useResolutions } from '../../hooks/export'

interface ChartCsvExportButtonProps {
  onExport: (resolution: Resolution) => Promise<void>
  isFetching: boolean
  tooltip?: string
  dataQa?: string
}

/**
 * This component renders a button and a menu via which data can be exported in different resolutions.
 */
const ExportWrapper: React.FC<ChartCsvExportButtonProps> = ({ onExport, isFetching, tooltip, dataQa }) => {
  const { t } = useCustomTranslation()
  const buttonRef = useRef<HTMLButtonElement>(null)
  const { menuAnchor, onMenuClose, handleMenuOpen, resolution, resolutionMenuItems } = useResolutions()
  const hasMenuOptions = resolutionMenuItems.length > 1

  const handleButtonClick = (event: React.MouseEvent<HTMLElement>): Promise<void> | void => {
    if (hasMenuOptions) return handleMenuOpen(event)
    return onExport(resolution)
  }

  return (
    <Tooltip title={tooltip ?? t('systemDataHandler.chartHeader.export')}>
      <Box component="span">
        <ExportMenu items={resolutionMenuItems} menuAnchor={menuAnchor} isLoading={false} onClose={onMenuClose} onExport={onExport} />
        <ExportButton isLoading={isFetching} onClick={handleButtonClick} buttonRef={buttonRef} dataQa={dataQa} />
      </Box>
    </Tooltip>
  )
}

export default ExportWrapper
